module.exports = __webpack_public_path__ + "img/manyArea.92bab28e.png";